module.exports = __webpack_public_path__ + "static/media/natal.c3504d10.png";